.wrapper {
  min-height: 100%;
}

.container {
  height: 300px;
  min-height: 100%;
}
